module.exports = __webpack_public_path__ + "client/img/invest_05.2a430cf8.png";